import styles from './util-styles.module.css';

export const blockSeparator = styles.blockSeparator;